import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';

import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { HTTPService, DataService, DateService, FormatService, HelperService } from 'app/services';
import { config } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { SelectedItemsService } from 'app/services/selectedItems.service';
import { CreateStatementDialogComponent } from 'app/modules/app-components';

@Component({
  selector: 'app-bulk-statement-dialog',
  templateUrl: './bulk-statement-dialog.component.html',
  styleUrls: ['./bulk-statement-dialog.component.scss'],
  providers: [DialogService],
})
export class BulkStatementDialogComponent implements OnInit, OnDestroy {
  @ViewChild('addManualPartOrderingBody', { static: true }) addManualPartOrderingBody: ElementRef;

  @ViewChild('itemDateCalender')
  invDateCalender: ElementRef;
  isSubmitting: boolean = false;
  isSubmittingGenerateAndSend: boolean = false;
  isSubmittingGenerate: boolean = false;
  config = config;
  filterOptions = {
    date: true,
    dateRang: true,
    statementStatus: false,
    paidStatus: true,
  };
  moveInvoice: boolean = false;
  bulkStatementList: any;
  columns: any[] = [];
  selectAllItems = false;
  tableConfig = {
    createdAtStart: '',
    createdAtEnd: '',
    isUnpaid: null,
    isPaidPartial: null,
    isPaidFull: null,
    isSent: null,
    orderStatus: null,
    sortField: 'createdAt',
    sortOrder: -1,
    skip: 0,
    limit: 8,
    offset: 0,
    search: '',
    newStatementList: true,
  };

  totalRecords: number;
  searchQuery: string = '';
  activeStatus: any = true;
  poType: string = '';
  restockLevel: string = '';
  locations: string[] = [];
  selectedFilter: any = {
    poStatus: '',
    suppliers: [],
  };
  loading: boolean = true;
  tableCheckState: number = 0;

  bulkItemList: any[] = [];
  currentDateTime: any;
  currentPage = 0;
  pinnedIconTooltip: string;
  dateType: string = '';
  preAppliedFilters: any = {
    paidStatus: {
      unPaid: true,
      partiallyPaid: true,
      paid: false,
    },
  };

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dataService: DataService,
    private httpService: HTTPService,
    public helperService: HelperService,
    private formatService: FormatService,
    public selectedItemsService: SelectedItemsService,
    private dialogService: DialogService
  ) {}

  async ngOnInit() {
    const { companyId, isRevenueRecognitionSettleEnabled } = this.helperService.getCompany();
    this.dateType = isRevenueRecognitionSettleEnabled ? 'Finialize date' : 'Invoice date';
    this.selectedItemsService.clearSelectedItems();
    this.columns = [
      { field: 'name', header: 'Name', className: 'customer-name new-statment-bg' },
      { field: 'statementName', header: 'Statement name', className: 'statement-name new-statment-bg' },
      { field: 'newInvoiceCount', header: 'Invoices (#)', className: 'new-in-code new-statment-bg' },
      { field: 'newTotal', header: 'Total amount', className: 'new-total-amount new-statment-bg' },
      { field: 'newUnpaid', header: 'Outstanding balance', className: 'new-balance new-statment-bg font-600' },
      { field: 'previousInvoiceCount', header: 'Invoices (#)', className: 'old-invoices old-statment-bg' },
      { field: 'previousTotalAmount', header: 'Total amount', className: 'old-total-amount old-statment-bg font-600' },
      { field: 'previousUnpaid', header: 'Outstanding balance', className: 'old-balance old-statment-bg font-600' },
    ];

    // this.getCustomerStatmentList();
    this.setPinnedTooltip();
  }

  handlemoveInvoices(value) {
    this.moveInvoice = value;
    if (value === false) {
      this.selectedItemsService.clearSelectedItems();
    }
  }

  filterChange(filters) {
    if (!filters?.date?.startDate) return;
    if (filters?.date?.startDate) {
      this.tableConfig.createdAtStart = filters?.date?.startDate;
      this.tableConfig.createdAtEnd = filters?.date?.endDate;
    } else {
      this.tableConfig.createdAtStart = '';
      this.tableConfig.createdAtEnd = '';
    }

    // check if paid status filter applied, if not remove filter
    // clear filter first
    this.tableConfig.isPaidFull = null;
    this.tableConfig.isPaidPartial = null;
    this.tableConfig.isUnpaid = null;
    if (filters.paidStatus) {
      const { unPaid, partiallyPaid, paid } = <any>(filters.paidStatus || {});

      // if not filters applied or not all unselected
      if (!((unPaid && partiallyPaid && paid) || (!unPaid && !partiallyPaid && !paid))) {
        if (unPaid) this.tableConfig.isUnpaid = true;
        if (partiallyPaid) this.tableConfig.isPaidPartial = true;
        if (paid) this.tableConfig.isPaidFull = true;
      }
    }

    // check if send status applied
    this.tableConfig.isSent = null;
    if (filters.sendStatus) {
      const { notSent, sent } = filters.sendStatus;

      if (!((notSent && sent) || (!notSent && !sent))) {
        if (sent) this.tableConfig.isSent = true;
        if (notSent) this.tableConfig.isSent = false;
      }
    }

    // check if order status filter applied
    this.tableConfig.orderStatus = null;
    if (filters.orderStatus) {
      const { estimate, invoice } = filters.orderStatus;

      if (!((estimate && invoice) || (!estimate && !invoice))) {
        if (estimate) this.tableConfig.orderStatus = 'estimate';
        if (invoice) this.tableConfig.orderStatus = 'invoice';
      }
    }

    // reset current offset for filters as well
    this.tableConfig.offset = 0;

    // this.searchResults = [];
    this.getCustomerStatmentList();
  }

  /**
   * Close Modal
   * @param isSuccess
   */
  public handleClose(isSuccess: boolean = false): void {
    this.dynamicDialogRef.close({ isSuccess });
  }

  async handleSubmit(type) {
    let statements = [];
    this.bulkItemList = this.selectedItemsService.getSelectedItems();
    this.bulkItemList.map((item) => {
      if (item.newInvoiceCount == 0 && !this.moveInvoice) {
        return;
      }
      statements.push({
        name: item?.statementName,
        invoices: this.moveInvoice ? item.newInvoices.concat(item?.previousInvoices) : item.newInvoices || [],
        customerId: item._id,
        customerName: item?.name,
        isForcedMoveInvoice: this.moveInvoice,
        isSubmittingGenerate: true,
      });
    });

    if (statements?.length) {
      this[type] = true;
      try {
        const data = await this.httpService.createBulkStatements({ statements, isSubmittingGenerateAndSend: this.isSubmittingGenerateAndSend });
        if (data) {
          this.dataService.sendData(this.dataService.typePassData('bulk-statement-response', data));
          if (!this.isSubmittingGenerateAndSend) {
            this.isSubmittingGenerate = false;
            this.helperService.showToaster('success', 'Bulk statement created');
          }
          this.isSubmittingGenerate = false;
          this.dynamicDialogRef.close({ isSuccess: true, isSendingBulkStatements: this.isSubmittingGenerateAndSend });
        }
      } catch (err) {
        this.helperService.showToaster('error', err);
        console.log(err);
        this.dynamicDialogRef.close();
        this[type] = true;
      }
    } else {
      this.helperService.showToaster('error', 'Please select statements');
    }
  }

  ngOnDestroy(): void {
    this.selectedItemsService.clearSelectedItems();
  }

  isPageHasAllItemDisabled(): boolean {
    if (!this.moveInvoice) {
      const selectedItemsData = this.bulkStatementList?.filter((item) => item.newInvoiceCount !== 0);
      if (!selectedItemsData?.length) {
        return true;
      }
    }
    return false;
  }

  private async getCustomerStatmentList() {
    await this.httpService
      .getCustomerStatementList(this.tableConfig)
      .then(
        (response) => {
          this.bulkStatementList = this.formatService.formatCustomerBulkStatementList(response.records);
          this.totalRecords = response.metaData.totalRecords;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.loading = false;
      });
  }

  paginate(data: any) {
    this.currentPage = data.page;
    this.tableConfig.skip = data.first;
    this.selectAllItems = false;
    this.getCustomerStatmentList();
  }
  // for single item
  toggleSelection(item: any) {
    if (item.newInvoiceCount == 0 && !this.moveInvoice) return;
    this.selectedItemsService.toggleItem(this.currentPage, item);

    if (!this.selectedItemsService.isAllPageItemsSelected(this.currentPage, this.bulkStatementList)) {
      this.tableCheckState = 2;
    } else if (this.selectedItemsService.isAllPageItemsSelected(this.currentPage, this.bulkStatementList)) {
      this.tableCheckState = 1;
    } else {
      this.tableCheckState = 0;
    }
  }

  // for all items and page
  toggleSelectAll() {
    // filter out in case of move invoices not checked and new invoice count is zero
    let selectedItemsData = this.bulkStatementList;
    if (!this.moveInvoice) {
      selectedItemsData = this.bulkStatementList.filter((item) => item.newInvoiceCount !== 0);
    }
    this.selectedItemsService.toggleSelectAll(this.currentPage, selectedItemsData);
    if (!this.selectedItemsService.isAllPageItemsSelected(this.currentPage, selectedItemsData)) {
      this.tableCheckState = 0;
    } else if (this.selectedItemsService.isAllPageItemsSelected(this.currentPage, selectedItemsData)) {
      this.tableCheckState = 1;
    } else {
      this.tableCheckState = 0;
    }
  }

  // Invoices dialog
  // isOpenFromBulk, invoices
  openStamentsDetails(data) {
    if (data?.newInvoiceCount === 0 && !data.bulkPreviousInvoices?.length) {
      return;
    }
    this.dialogService.open(CreateStatementDialogComponent, {
      width: '1110px',
      styleClass: 'add-dialog add-statement-modal',
      showHeader: false,
      data: { isOpenFromBulk: true, invoices: this.moveInvoice ? data?.bulkPreviousInvoices : data?.bulkNewInvoices, name: data?.statementName },
    });
  }

  setPinnedTooltip() {
    this.pinnedIconTooltip = `
      <div class="text-left" style="width: 210px;">
        <div class="font-12 font-secondary-800">
        <p class="mb-0 d-flex">
        <i class="fas fa-info-circle mr-2 mt-2 font-warning-800 font-14"></i>
        This section displays invoices for each customer that belongs to the selected duration but have already been included in previous statements
        </p>
        </div>
    `;
    this.pinnedIconTooltip += '</div>';
  }
}
